import { IconButton, SingleNeutralActionsAddIcon, Tooltip } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { useTrackScheduleFeaturesInteraction } from '@spa/core/externals/segment'
import { useMemoSelector } from '@spa/redux/hooks'
import { createMembershipModalDef } from '@spa/scenes/Plannings/Modals/CreateMembershipModal/CreateMembershipModal'
import { getParams } from '@spa/scenes/Plannings/redux/selectors'
import React from 'react'
import type { FC } from 'react'

type Props = {
  teamId: number
}
const AddEmployeeContainer: FC<Props> = ({ teamId }) => {
  const { t } = usePlanningTranslation()
  const { locationId } = useMemoSelector(getParams)
  const { open } = createMembershipModalDef.useDispatchModal()
  const scheduleTracker = useTrackScheduleFeaturesInteraction()

  const handleOpen = () => {
    scheduleTracker.employeeCreationModalOpened()
    open({ teamId, locationId })
  }

  return (
    <Tooltip label={t('weekly.header.addEmployee')}>
      <IconButton
        variant='tertiary'
        intent='neutral-dark'
        size='s'
        onClick={handleOpen}
        icon={<SingleNeutralActionsAddIcon />}
      />
    </Tooltip>
  )
}
export default AddEmployeeContainer
